import React from 'react';
import Toggle from './Toggle';

const DeckSize = ({ onChange, isChecked }) => {
  return (
    <div className="field">
      <label className="field_label" htmlFor="deck_railing">Deck Railing</label>
      <span className="field_description">Should the deck have a railing around the perimeter?</span>
      <Toggle onChange={e => onChange(e, 'railing')} isChecked={isChecked} name="deck_railing"/>
    </div>
  );
};

export default DeckSize;
